export default function(api: GlobalFetch) {
  return async function(id) {
    const response = await api.fetch(`/api/v2/amentity/index/id_object/` + id, {
      method: 'GET',
    })

    const json = await response.json()
    return json.items
  }
}
